import { Box, Flex, HStack, Text, Badge, Button } from '@chakra-ui/react'
import { ChevronDown } from 'lucide-react'
import { TaskFiltersBar, UrgentNewQueue } from '@/components/helpdesk'
import { useHelpdeskRequests } from '@/hooks/useHelpdeskRequests'
import { useAcknowledgeRequest } from '@/hooks/useAcknowledgeRequest'
import { Pagination } from '@/components/tables'
import { ExportButton } from '@/components/common/ExportButton'
import { QueueCountBadge } from '@/components/common/QueueCountBadge'

export default function TaskList() {
  const {
    urgentNew,
    urgentNewAllCount,
    urgentNewMeta,
    setUrgentNewPageFromUrl,
    acknowledge,
  } = useHelpdeskRequests()

  const { acknowledge: ackAsync, loadingId } = useAcknowledgeRequest(acknowledge)

  return (
    <Box p={6} w="100%" minW={0} overflowX="auto">
      <Flex direction="column" gap={10} minW={0}>
        {/* ===================== Urgent / New ===================== */}
        <Box minW={0}>
          <HStack justify="space-between" align="center" mb={3}>
            <HStack>
              <Text fontWeight="semibold" color="red.600">
                Urgent / New (Timer Running)
              </Text>

              <QueueCountBadge
                label="Total Requests"
                count={urgentNewAllCount}
              />

            </HStack>

           <ExportButton isDisabled={!urgentNew.length} />

          </HStack>

          <Box borderBottom="1px solid" borderColor="gray.200" mb={4} />

          <TaskFiltersBar />

          <Box mt={3} maxH="520px" overflowY="auto" overflowX="auto" minW={0}>
            <Box minW="1100px">
              <UrgentNewQueue data={urgentNew} onAcknowledge={ackAsync} loadingId={loadingId} />
            </Box>
          </Box>

          <HStack
            justify="space-between"
            mt={3}
            pt={3}
            borderTop="1px solid"
            borderColor="gray.200"
            align="center"
          >
            <Text fontSize="sm" color="gray.600">
              Show{' '}
              <Box as="span" fontWeight="600">
                {urgentNewMeta?.per_page ?? 10}
              </Box>{' '}
              Results
            </Text>

            {urgentNewMeta ? (
              <Box minW="fit-content">
                <Pagination metas={urgentNewMeta} onClick={setUrgentNewPageFromUrl} />
              </Box>
            ) : (
              <Box />
            )}
          </HStack>
        </Box>
      </Flex>
    </Box>
  )
}